"use client";
import { useEffect, useRef, useState } from "react";

export default function Spiral() {
  const wrapper = useRef(null);
  const initRef = useRef(false);
  const [op, setOp] = useState(0);

  useEffect(() => {
    const loadScript = () => {
      if (initRef.current) return;
      console.log("load script");
      const script = document.createElement("script");
      script.id = "spiral";
      script.src = "/js/spiral.js";
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        setTimeout(() => {
          setOp(1);
        }, 5000);
      };
    };
    if (wrapper.current) {
      loadScript();
    }
    return () => {
      initRef.current = true;
    };
  }, []);

  return (
    <div
      ref={wrapper}
      className="opacity-[${op}] m-4 mx-auto flex h-[280px] w-full justify-items-center overflow-x-clip bg-white md:h-[280px]"
    >
      <div id="spiral" className="spiral"></div>
      <div id="spiral2" className="spiral"></div>
    </div>
  );
}
